<template>
  <!-- The tile of an empty container template (2026-09-22): a live frame of
       it would be a white square. One box per column, as wide as the column
       is on a desktop; a picture mark where the column carries one; arrows
       when the row is swiped. -->
  <svg class="container-sketch" viewBox="0 0 120 72" aria-hidden="true">
    <template v-for="(box, i) in boxes">
      <rect :key="`b${i}`" :x="box.x" y="8" :width="box.w" height="56" rx="3" :class="{ 'is-image': box.image }" />
      <path
        v-if="box.image"
        :key="`p${i}`"
        :transform="`translate(${box.x + box.w / 2 - 7} 29)`"
        d="M1 12 L5 6 L8 9 L11 4 L14 12 Z M3 3 a1.5 1.5 0 1 0 0.01 0"
      />
    </template>
    <template v-if="sketch.swipe">
      <path d="M8 36 L3 32 L8 28" class="arrow" />
      <path d="M112 36 L117 32 L112 28" class="arrow" />
    </template>
  </svg>
</template>

<script>
const WIDTH = 120;
const GAP = 4;

export default {
  name: 'ContainerSketch',
  props: {
    /** `{ columns: [{ span, image }], swipe }`, see containerSketch(). */
    sketch: { type: Object, required: true },
  },
  computed: {
    // Columns wrap like the real 12-track grid: a row of four sixths is
    // two rows of two, drawn as one row for the tile's sake.
    boxes() {
      const cols = this.sketch.columns;
      const inner = WIDTH - 2 * GAP;
      let x = GAP;
      return cols.map((col) => {
        const w = Math.max(6, (inner - GAP * (cols.length - 1)) * (col.span / 12));
        const box = { x, w, image: col.image };
        x += w + GAP;
        return box;
      });
    },
  },
};
</script>

<style scoped>
.container-sketch {
  display: block;
  width: 100%;
  height: 100%;
  max-height: 96px;
}

rect {
  fill: #e5e7eb;
}

rect.is-image {
  fill: #c7d2fe;
}

path {
  fill: #4f46e5;
}

.arrow {
  fill: none;
  stroke: #6b7280;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
